import { render, staticRenderFns } from "./UnificacionPacientes_View.vue?vue&type=template&id=0f9d5fcd&scoped=true"
import script from "./UnificacionPacientes_View.vue?vue&type=script&lang=js"
export * from "./UnificacionPacientes_View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d5fcd",
  null
  
)

export default component.exports